<div class="modal-close" (click)="closeModal()">
  <fa-icon class="icon me-1" [icon]="faTimes"></fa-icon>
  <span>{{ 'btn:close' | translate }}</span>
</div>
<div class="modal-header">
  <h4 class="modal-title">
    {{ 'video:replace:modal:title' | translate }}{{ (fileName ? ': ' + fileName : '') | excerpt: 55 }}
  </h4>
</div>
<div class="modal-body">
  <p class="fs-14 text-muted" *ngIf="!uploading && !uploaded">
    {{ 'video:replace:modal:description' | translate }}
  </p>

  <div class="row justify-content-center" *ngIf="!uploading && !uploaded">
    <div class="col-auto">
      <ngx-file-drop
        #fileDrop
        dropZoneLabel="Drop files here"
        [accept]="acceptFileUpload"
        (onFileDrop)="fileDropped($event)"
      >
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
          <div class="text-center p-3 pt-0">
            <div class="btn btn-primary mb-3" (click)="openFileSelector($event)">
              {{ 'video:upload:browse:button' | translate }}
            </div>
            <h6>{{ 'video:upload:drag:drop:text' | translate }}</h6>
            <p class="mb-1 fs-14">{{ 'video:upload:supported:types' | translate }}</p>
            <p class="mb-0 fs-14">
              {{ 'video:upload:max:size' | translate: { maxSize: isAdmin() ? '10GB' : '300MB' } }}
            </p>
          </div>
        </ng-template>
      </ngx-file-drop>
    </div>
  </div>

  <div class="text-center my-4" *ngIf="uploading">
    <p class="mb-2">{{ 'video:replace:uploading' | translate }}</p>
    <app-progress-bar
      [progress]="uploadingProgress"
      [showLabelText]="false"
      [labelPosition]="'right'"
    ></app-progress-bar>
  </div>

  <div class="text-center my-4" *ngIf="uploaded">
    <p class="text-success mb-0">
      {{ 'video:replace:success:short' | translate }} <i class="fas fa-check"></i>
    </p>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-link" (click)="closeModal()" [disabled]="uploading">
    {{ (uploaded ? 'btn:close' : 'btn:cancel') | translate }}
  </button>
</div>
